import React from "react";

const ICONS = {
  success: "fa-check",
  error: "fa-times",
  warning: "fa-exclamation",
  info: "fa-info"
};

const TITLES = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Notice"
};

const normalizeTone = (tone) => {
  if (tone === "success" || tone === "error" || tone === "warning" || tone === "info") {
    return tone;
  }
  return "info";
};

const ToastMessage = ({ tone, title, message, onClose }) => {
  const resolvedTone = normalizeTone(tone);
  const resolvedTitle = (typeof title === "string" && title.trim() !== "" ? title : TITLES[resolvedTone]);
  const resolvedMessage = (typeof message === "string" && message.trim() !== "" ? message : "");

  return (
    <div className={"app-toast-content is-" + resolvedTone}>
      <div className="app-toast-icon" aria-hidden="true">
        <i className={"fa " + ICONS[resolvedTone]} />
      </div>
      <div className="app-toast-copy">
        <div className="app-toast-title">{resolvedTitle}</div>
        {resolvedMessage !== "" && <div className="app-toast-message">{resolvedMessage}</div>}
      </div>
      <button type="button" className="app-toast-close" onClick={onClose} aria-label="Close notification">
        <i className="fa fa-times" aria-hidden="true" />
      </button>
    </div>
  );
};

export default ToastMessage;
